let variantInput = document.querySelectorAll(
  ".product--info .variants-option input"
);
let formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: Shopify.currency.active,
});

//////////// updating quantity
function quantityUpdate(el, type) {
  let qnInput = el.closest(".quantity-input").querySelector("input");
  let currentQuantity = Number(qnInput.value);
  if (type == "increment") {
    qnInput.value = currentQuantity + 1;
  } else if (type == "decrement") {
    qnInput.value > 1 ? (qnInput.value = currentQuantity - 1) : "";
  }
}
/////////////////////Updating variants
function updateVariant(el) {
  let selectedOpt;
  let selectedOptArr = Array.from(
    el.closest(".variant-selectors").querySelectorAll("input")
  )
    .filter((el) => el.checked)
    .map((el) => el.value);
  let productData = JSON.parse(
    el.closest("form").querySelector("script").innerText
  );
  let variantsData = productData.variants;
  selectedOpt = variantsData.filter(
    (el) =>
      el.options.length == selectedOptArr.length &&
      el.options.every((el) => selectedOptArr.indexOf(el) != -1)
  );
  el.closest("form").querySelector('input[name="id"]').value =
    selectedOpt[0].id;
  console.log(el.closest("form").querySelectorAll("button"));
  el.closest("form")
    .querySelectorAll("button")
    .forEach(function (el, ind) {
      if (selectedOpt[0].available == true) {
        el.removeAttribute("disabled");
      } else {
        el.setAttribute("disabled", true);
      }
    });
  ////Updating variant data
  let fetchUrl = window.location.pathname + `?variant=${selectedOpt[0].id}`;
  console.log(fetchUrl);
  fetch(fetchUrl)
    .then((resp) => resp.text())
    .then((data) => {
      var parser = new DOMParser();
      var html = parser.parseFromString(data, "text/html");
      let variantSku = html.querySelector(".product-sku") ? html.querySelector(".product-sku").innerHTML : null;
      let variantDiscount = html.querySelector(".product-discount").innerHTML;
      let variantPrice = html.querySelector(".price-wrap").innerHTML;
      // variantSku
      //   ? (document.querySelector(".product--info .product-sku").innerHTML =
      //       variantSku)
      //   : (document.querySelector(".product--info .product-sku").innerHTML =
      //       "");
      variantDiscount
        ? (document.querySelector(
            ".product--info .product-discount"
          ).innerHTML = variantDiscount)
        : (document.querySelector(
            ".product--info .product-discount"
          ).innerHTML = "");
      variantPrice
        ? (document.querySelector(".product--info .price-wrap").innerHTML =
            variantPrice)
        : (document.querySelector(".product--info .price-wrap").innerHTML = "");
    });
}
///////////////////Listeners
// document.addEventListener("click", function (e) {
//   if (
//     e.target.classList.contains("qn-minus") ||
//     e.target.closest(".qn-minus")
//   ) {
//     e.preventDefault();
//     let el = e.target.classList.contains("qn-minus")
//       ? e.target
//       : e.target.closest(".qn-minus");
//     quantityUpdate(el, "decrement");
//   }
// });
// document.addEventListener("click", function (e) {
//   if (e.target.classList.contains("qn-plus") || e.target.closest(".qn-plus")) {
//     e.preventDefault();
//     let el = e.target.classList.contains("qn-plus")
//       ? e.target
//       : e.target.closest(".qn-plus");
//     quantityUpdate(el, "increment");
//   }
// });
variantInput.forEach(function (el, ind) {
  el.addEventListener("click", function () {
    updateVariant(el);
  });
});
